import React, {useEffect, useState, FunctionComponent} from 'react'
import styled from 'styled-components'
import { styles } from '../styles/themes/style'
import { useAuthHandlers } from '../services/actions/auth/useAuthHandlers'
import { useAuthStore } from '../stores/auth/useAuthStore'
import SvgFragment from './SvgFragment'
import { crispOn, crispOpen } from '../services/crisp/crisp'

const CrispChat: FunctionComponent = () => {
    const { saveUserPreferencesHandler } = useAuthHandlers()
    const { store: { user } } = useAuthStore()
    const [toggleChat, setToggleChat] = useState(true)

    useEffect(() => {
        crispOn("chat:closed", () => { setToggleChat(true) })
    }, [])

    const onCloseHandler = async () => {
        setToggleChat(user?.preferences?.crispChat === undefined ? false : !user?.preferences?.crispChat)
        await saveUserPreferencesHandler({crispChat: user?.preferences?.crispChat === undefined ? false : !user?.preferences?.crispChat})
    }

    return (        
        <>
            {toggleChat &&
                <Container>
                    {user && (
                        <SvgClose onClick={onCloseHandler}><SvgFragment type='close' /></SvgClose>
                    )}
                    <ChrispChat onClick={() => { crispOpen(); setToggleChat(false) }}/>
                </Container>
            }
        </>        
    )
}

const Container = styled.div`
    position: absolute;
    z-index: 10000000;
    bottom: 105px;
    right: 15px;
    width: 80px;
    height: 80px;
    cursor: pointer;

    &:hover div { display: block }
`
const SvgClose = styled.div`
    display: none;
    position: absolute;
    left: 58px;
    bottom: 61px;
    cursor: pointer;
`
const ChrispChat = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 60px;
    height: 60px;
    cursor: pointer;
`
export default CrispChat